import { UUID } from "../../model/uuid";
import { Token } from "./token";
import { Tag } from "./tag";
import { Token as TokenModel } from "../../model/structure";
import { TaggedToken as TaggedTokenModel } from "../../model/structure";
import { TaggingAnnotationScheme } from "../../annotation/scheme";

interface TaggedTokenProps extends TokenModel {
	annotationScheme: TaggingAnnotationScheme;
	activeTypeId: UUID | null;
	taggedToken?: TaggedTokenModel;
	onClick: (event: React.MouseEvent) => void;
	onSelect: (typeId: UUID) => void;
}

export function TaggedToken(props: TaggedTokenProps) {
	let tag = "";

	if (
		props.taggedToken !== undefined &&
		props.taggedToken.tag !== undefined
	) {
		tag = props.taggedToken.tag;
	}

	return (
		<span className="token tagged" onClick={props.onClick}>
			{/* <Token 
             tokenIndex={props.tokenIndex} 
             text={props.text}
             metaKeyClicked={false}
             shiftKeyClicked={false}
             currentMentionModel='entity'
            /> */}
			<Tag
				annotationScheme={props.annotationScheme}
				activeTypeId={props.activeTypeId}
				value={tag}
				onSelect={props.onSelect}
			/>
		</span>
	);
}
